module.exports = __webpack_public_path__ + "static/media/HomeSuccess.feb70df6.png";